module.exports = __webpack_public_path__ + "img/emotion-customization@2x.2d8520d.jpg";